module.exports = __webpack_public_path__ + "img/7-s.39d46f7f.png";